
import Vue from 'vue'

export default Vue.extend({
  name: 'BarList',
  props: {
    items: { type: Array as () => Array<{ label: string; value: number }>, default: () => [] },
    color: { type: String, default: '#5b6af0' },
    colorMap: { type: Object as () => Record<string, string>, default: () => ({}) },
    emptyText: { type: String, default: 'Veri yok' }
  },
  computed: {
    max (): number {
      return this.items.reduce((m, it) => Math.max(m, it.value || 0), 0)
    }
  },
  methods: {
    percent (value: number): number {
      if (!this.max) return 0
      return Math.round((value / this.max) * 100)
    },
    barColor (label: string): string {
      return this.colorMap[label] || this.colorMap[(label || '').toUpperCase()] || this.color
    }
  }
})
